import type { SWRResponse } from "swr";
import { useFetcher } from "~/hooks/useFetcher";
import {
  AIRFLOW_RUN_TERMINAL_STATES,
  publicDatasetRunStatusPath,
  type PublicDatasetRunStatus,
} from "~/services/publicDatasetRuns";

// Pipeline runs take minutes, not seconds — eval-run/ingest's 3s default
// would be wasted load here.
const POLL_INTERVAL_MS = 30_000;

// dagId/runId are separate nullable params, not one composite id — they come
// from two different upstream sources (trigger args vs. its result) and both
// must resolve before the request fires.
export const usePublicDatasetRunStatus = (
  dagId: string | null,
  runId: string | null
): SWRResponse<PublicDatasetRunStatus> =>
  useFetcher<PublicDatasetRunStatus>(
    dagId && runId ? publicDatasetRunStatusPath(dagId, runId) : null,
    {
      shouldCamelize: true,
      refreshInterval: (latest?: PublicDatasetRunStatus) =>
        latest && AIRFLOW_RUN_TERMINAL_STATES.has(latest.state) ? 0 : POLL_INTERVAL_MS,
    }
  );
